var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.409 3.38805C12.5054 3.02169 11.4946 3.02169 10.591 3.38805L8.401 4.27605L17.993 8.00605L21.367 6.70305C21.2287 6.58827 21.0736 6.49551 20.907 6.42805L13.409 3.38805ZM22 8.06605L12.75 11.6401V22.5631C12.974 22.5181 13.194 22.4511 13.409 22.3641L20.907 19.3241C21.23 19.1932 21.5065 18.969 21.7013 18.68C21.896 18.391 22 18.0505 22 17.7021V8.06705V8.06605ZM11.25 22.5631V11.6401L2 8.06605V17.7031C2.0002 18.0513 2.10431 18.3916 2.29903 18.6804C2.49374 18.9692 2.77019 19.1933 3.093 19.3241L10.591 22.3641C10.806 22.4511 11.026 22.517 11.25 22.5641V22.5631ZM2.633 6.70305L12 10.3221L15.917 8.80805L6.374 5.09805L3.093 6.42805C2.923 6.49705 2.769 6.59005 2.633 6.70305Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxAlt);
export default __webpack_public_path__ + "static/media/box-alt.c3a67346b48fc11ee34e5d95b9b96971.svg";
export { ForwardRef as ReactComponent };